window.HelloworkCookieConsentCustomConfig = {
    noticeIntroductionText: "Nous utilisons des cookies pour vous suggérer les offres d’emploi les plus adaptées à votre recherche.",
    noticeModal: true,
    primaryBtnBackgroundColor: "#333333", // gris foncé neutre, lisible sur les 4 variantes de theme
    privacyPolicyUrl: "/page/infos-legales.html",
    termsOfServiceUrl: "/page/cgu.html",
};

//Cookie Consent: Initialization
document.addEventListener("DOMContentLoaded", function () {
    window.helloworkCookieConsent = new HelloworkCookieConsent();
});